module.exports = __webpack_public_path__ + "img/a4.c62922f0.svg";